import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { appointmentService } from '../../../services/appointmentService';
import { supabase } from '../../../lib/supabase';
import Button from '../../../components/ui/Button';

const today = new Date()?.toISOString()?.split('T')?.[0];


const DispatchRemindersModal = ({ 
  isOpen, 
  onClose,
  onSuccess,
  onError,
  psychologistProfile
}) => {
  
const [isSubmitting, setIsSubmitting] = useState(false);
const [errors, setErrors] = useState({});

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    };
  }, [isOpen]);

  // ESC key handler to close modal
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event?.key === 'Escape' && isOpen && !isSubmitting) {
        handleClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscapeKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isOpen, isSubmitting]);


  const handleClose = () => {
    setErrors({});
    onClose();
  };

  const handleDispatch = async () => {
    try {

      // Call Supabase edge function to manually send reminders. 
      const { data, error } = await supabase?.functions?.invoke('send-by-psychologist-reminders', {
        body: {
          id: psychologistProfile.id
        }
      });

      if (error) throw error;

      // Sucesso.
      onSuccess();

      return data;

    } catch (error) {
      console.error('Error at dispatch reminders:', error);
      onError();
      throw error;
    }

  };


  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm overflow-y-auto"
        onClick={handleClose}
      >
         {/* Container principal do modal */}
        <div 
          className="bg-card rounded-xl shadow-2xl border border-border w-full max-w-2xl max-h-[95vh] flex flex-col overflow-hidden mx-auto my-auto"
          style={{ minHeight: '73vh', maxHeight: '96vh' }}
          onClick={(e) => e?.stopPropagation()}
        >

          {/* Header */}
          <div className="sticky top-0 bg-card border-b border-border px-6 py-4 flex items-center justify-between z-10 shadow-sm">
            <h2 className="text-xl font-semibold text-foreground">
              Disparo de Lembretes
            </h2>
            <button
              onClick={handleClose}
              className="w-8 h-8 rounded-lg hover:bg-muted transition-smooth flex items-center justify-center"
            >
              <Icon name="X" size={20} />
            </button>
          </div>

          {/* CORPO DO MODAL – AQUI VAI TODO O CONTEÚDO AQUI DENTRO */}
          <div className='px-8 py-5'>
            <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
              <Icon name="MessageSquareShare" size={20} color="var(--color-primary)" />
              Clique no botão para enviar
            </h3>

            <p>
              <br/>
              <strong>Lembretes automáticos</strong><br/>
            </p>
            <div>
              <br/>  
              Os lembretes já são enviados automaticamente para pacientes com consultas agendadas para hoje,
              com a antecedência configurada em <div className="inline-flex items-center gap-2 ml-1"><Icon name="Bell" size={20} /><strong>Notificações</strong></div>
            </div>

            <div>
              <br/>
              <strong>Envio manual</strong><br/>
            </div>
            <div>
              <br/>
              Use o botão abaixo para enviar um novo lembrete imediatamente a todos os pacientes com consulta
              hoje que ainda não confirmaram.
            </div>
          </div>

          <div className="px-6 pb-6 pt-4 flex flex-col gap-3 md:flex-row md:items-center md:gap-3 md:pt-8 md:ml-8 md:mr-8">
            <Button
              type="button"
              variant="outline"
              onClick={handleClose}
              className="w-full"
            >
              Retornar
            </Button>
            <Button
              type="button"
              variant="default"
              onClick={handleDispatch}
              iconName="Check"
              iconPosition="right"
              className="w-full"
            >
              Disparar Lembretes
            </Button>
          </div>

        </div>
        </div>
        
    </>
  );
};

export default DispatchRemindersModal;